
import { functions, storage, db } from '../firestore';
import { currentTenant } from '../stores/tenant.js';


export async function productCreate(data) {
    return new Promise(async (resolve, reject) => {

        console.log(data)
        // var file = data.document.logo;
        // if(file != null){
        //     var storageRef = storage.ref(`tenants/${get__store(currentTenant).tid}/${file.name}`);
        //     console.log(storageRef);
        //     return storageRef.put(file).then(function(snapshot) {
        //         console.log('Uploaded a blob or file!');
        //         data.document.file = snapshot.metadata.fullPath
        //         return doPost('productCreate', data);
        //     });
        // }
        // else{
        //     return doPost('productCreate', data);
        // }

        var file = data.logo;
        if (file != null) {
            var storageRef = storage.ref(`tenants/${get__store(currentTenant).tid}/${file.name}`);
            return storageRef.put(file).then(async function (snapshot) {
                data.logo = snapshot.metadata.fullPath
                const rVal = await doPost('productCreate', data);
                resolve(rVal.data);
            });
        }
        else {
            const rVal = await doPost('productCreate', data);
            resolve(rVal.data);
        }
    });
    // doPost('productCreate', data);
}

export async function featureCreate(data) {
    for (let i = 0; data.featureGroups.length > i; i++) {
        const file = data.featureGroups[i].image;
        if (file != null) {
            var storageRef = storage.ref(`tenants/${get__store(currentTenant).tid}/${data.id}/${file.name}`);
            let snapshot = await storageRef.put(file);
            data.featureGroups[i].image = snapshot.metadata.fullPath
        }
    }
    const rVal = await doPost('featureEdit', data);
    return (rVal.data);
}

export async function productEdit(data) {
    return new Promise(async(resolve, reject) => {

        //const rVal = await doPost('featureEdit', data);
        //return(rVal.data);
        // let dataToChange = {};
        // let runUpdate = false;
        // for (let key in model) {
        //     let val = model[key];
        //     if (val != null && val != '') {
        //         dataToChange[`texts.${key}`] = val;
        //         if (key == 'copies' && runUpdate == false) runUpdate = val.length > 0;
        //         else runUpdate = true;
        //     }
        // }

        if (get__store(currentTenant).tid == null)
            return;

        var file = data.logo;
        if (file != null) {
            if (file.name != null) {
                var storageRef = storage.ref(`tenants/${get__store(currentTenant).tid}/products/${data.id}`);
                const snapshot = await storageRef.put(file);
                data.logo = snapshot.metadata.fullPath
            }
        }

        let docRef = db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(data.id);
        if (docRef == null)
            return;

        delete data.id;
        try {
            const response = await docRef.update(data);
            resolve(response);
        } catch (e) {
            console.log('Error occurred on updateTexts in user doc', e);
            reject(e)
        }
    });
}

export async function personaEdit(data) {
    const rVal = await doPost('personaEdit', data);
    return (rVal.data);
}

export async function personaDataEdit(productId, personaId, data){
    return new Promise(async(resolve, reject) => {
        if (get__store(currentTenant).tid == null)
            return;

        let docRef = db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('buyerPersona').doc(personaId);
        if (docRef == null)
            return;

        delete data.pjg;
        try {
            const response = await docRef.update(data);
            resolve(response);
        } catch (e) {
            console.log('Error occurred on updateTexts in user doc', e);
            reject(e)
        }
    });
}

export async function pjgSave(productId, personaId, data){
    console.log(data);
    return new Promise(async(resolve, reject) => {
        if (get__store(currentTenant).tid == null)
            return;

        let docRef = db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('buyerPersona').doc(personaId).collection('pgj').doc(data.id);
        if (docRef == null)
            return;

        try {
            const response = await docRef.update({text: data.text, sortPos: data.sortPos});
            resolve(response);
        } catch (e) {
            console.log('Error occurred on updateTexts in user doc', e);
            reject(e)
        }
    });
}
export async function pjgAdd(productId, personaId, type, text, sortPos){
    return new Promise(async(resolve, reject) => {
        if (get__store(currentTenant).tid == null)
            return;

            let model = {
                text: text,
                sortPos: sortPos,
                type: type
            }
            db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('buyerPersona').doc(personaId).collection('pgj').add(model).then(async (docRef) => {

                docRef.update({id: docRef.id});
                model['id'] = docRef.id;
                resolve(model);

            });
        // let docRef = await db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('buyerPersona').doc(personaId).collection('pgj').doc();
        // if (docRef == null)
        //     return;

        // try {
        //     const response = await docRef.update({text: data.text});
        //     resolve(response);
        // } catch (e) {
        //     console.log('Error occurred on updateTexts in user doc', e);
        //     reject(e)
        // }
    });
}


export async function benefitCreate(data, buyerPersonaId) {
    for (let i = 0; data.benefits.items.length > i; i++) {
        const file = data.benefits.items[i].image;
        if (file != null) {
            var storageRef = storage.ref(`tenants/${get__store(currentTenant).tid}/${data.id}/${file.name}`);
            let snapshot = await storageRef.put(file);
            data.benefits.items[i].image = snapshot.metadata.fullPath
        }
    }
    const rVal = await doPost('benefitCreate', {data: data, buyerPersonaId: buyerPersonaId});
    return (rVal.data);
}

export async function benefitEdit(productId, personaId, benefit) {
    const data = benefit.data;
    console.log(benefit)
    console.log(productId)
    return new Promise(async(resolve, reject) => {
        if (get__store(currentTenant).tid == null)
            return;

        var file = data.image;
        if (file != null) {
            if (file.name != null) {
                let storageRef = storage.ref(`tenants/${get__store(currentTenant).tid}/products/${productId}/buyerPersona/${personaId}/benefits/${benefit.id}/${file.name}`);
                let snapshot = await storageRef.put(file);
                data.image = snapshot.metadata.fullPath
            }
        }

        let docRef = db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('buyerPersona').doc(personaId).collection('benefits').doc(benefit.id);
        if (docRef == null)
            return;

        delete data.id;
        try {
            const response = await docRef.update(data);
            resolve(response);
        } catch (e) {
            console.log('Error occurred on updateTexts in user doc', e);
            reject(e)
        }
    });
    // const rVal = await doPost('benefitEdit', data);
    // return (rVal.data);
}

export async function websiteCreate(productId, data){
    const rVal = await doPost('websiteCreate', {productId: productId, data: data});
    return (rVal.data);

    // return new Promise(async (resolve, reject) => {

    // const docRef = await db.collection("tenants").doc(get__store(currentTenant).tid).collection('products').doc(productId).collection('websites').doc();
    // docRef.set(data).then(function() {
    //     resolve({id: docRef.id, data: data })
    // })
    // .catch(function(error) {
    //     reject("Error writing document: ", error);
    // });

}

export async function websiteEdit(data){

}


export async function getBuyerPersona(productId, buyerPersonaId) {
    const rVal = await doPost('getBuyerPersona', { productId: productId, buyerPersonaId: buyerPersonaId });
    return (rVal.data);
}

export async function getFeatureGroups(productId) {
    const rVal = await doPost('getFeatures', { productId: productId });
    return (rVal.data);
}


export async function featureEdit(data) {
    alert('Needs to be implemented')
}



export async function createUserDoc(user) {
    return new Promise((resolve, reject) => {

        console.log('createUserDoc on Client');

        console.log(user);

        db.collection('users').doc(user.uid).set({
            displayName: user.displayName,
            email: user.email,
            initials: getInitials(user.displayName)
        }).then((result) => {
            resolve(result);

        }).catch((err) => {
            reject(err);
        });
    });
    // var func = functions.httpsCallable('createUserDoc');

    // return func(data).then(function(result) {
    //     console.log('createUserDoc Cloud Function Result')
    //     console.log(result)

    //    return result;
    // }).catch((err)=>{
    //     console.log('createUserDoc Cloud Function ERROR')
    //     console.log(err)
    //     return err
    // });
}


async function doPost(functionName, data) {
    return new Promise((resolve, reject) => {
        var func = functions.httpsCallable(functionName);
        func({ model: data, info: { tenantId: get__store(currentTenant).tid } }).then(function (result) {
            resolve(result);
        }).catch((err) => {
            reject(err)
        });
    });
}

function get__store(store) {
    let $val
    store.subscribe($ => $val = $)()
    return $val
}

export async function getWebsiteInfos(data) {
    let formData = `endpoint=${encodeURIComponent(data)}`;

    let xhr = new XMLHttpRequest();
    let baseurl = `http://localhost:9080`; //https://api.brandr.app/extract
    xhr.open("POST", baseurl);
    xhr.setRequestHeader("content-type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("Accept", "*/*");
    xhr.send(formData);

    return new Promise((resolve, reject) => {
        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === this.DONE) {
                resolve(JSON.parse(this.responseText));
            }
        });
    });
}

export function getHomepageScreenshot(url, fullPage) {
    //https://screenshotapi.net/
    /*RESULT
    "screenshot": "https://screenshot-api-net.storage.googleapis.com/unsplash_com-dgbgck8a7q4g.png",
    "url": "unsplash.com",
    "created_at": "2020-03-05 09:21:23",
    "is_fresh": false
     */
    const apiKey = `FIWDEXD9H4UXGQBHCUWMAMH9OUVYBCNG`;
    const getUrl = `https://screenshotapi.net/api/v1/screenshot?token=${apiKey}&url=${url}&width=1920&height=1080${fullPage == true ? '&full_page=true' : ''}`;
    let xhr = new XMLHttpRequest();

    xhr.open("POST", getUrl);
    xhr.setRequestHeader("content-type", "binary");
    xhr.setRequestHeader("Accept", "*/*");
    xhr.send(null);

    return new Promise((resolve, reject) => {
        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === this.DONE) {
                resolve(JSON.parse(this.responseText));
            }
        });
    });
}

const loadHtml = function (path, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', path, true);
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*");

    xhr.onreadystatechange = function () {
        if (this.readyState !== 4) return;
        if (this.status !== 200) return;
        callback(this.responseText);
    };
    xhr.send();
};
export function getHomepageText(url) {
    return new Promise((resolve, reject) => {
        //     loadHtml(url, function(html) {
        //         resolve(html);
        //         //document.querySelector('.page_content_wrapper').innerHTML = html;
        //       });
        var func = functions.httpsCallable('getWebsiteContent');

        func({ model: { url: url }, info: { tenantId: get__store(currentTenant).tid } }).then(function (result) {
            resolve(result);
        }).catch((err) => {
            reject(err)
        });

    });

    // let xhr = new XMLHttpRequest();

    // xhr.open("GET", url);
    // xhr.setRequestHeader("content-type", "document");
    // xhr.setRequestHeader("Accept", "*/*");
    // xhr.send(null);

    // return new Promise((resolve, reject) => {
    //     xhr.addEventListener("readystatechange", function () {
    //         if (this.readyState === this.DONE) {
    //             resolve(JSON.parse(this.responseText)); 
    //         }
    //     });
    // });
}

function getInitials(name) {
    var parts = name.split(' ');
    var initials = '';
    for (var i = 0; i < parts.length; i++) {
        if (parts[i].length > 0 && parts[i] !== '') {
            initials += parts[i][0]
        }
    }
    return initials.substring(0, 3);
}